import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { CustomersClient, GetCustomer } from 'src/app/generated-client/generated-client';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { AddCustomerDialogComponent } from '../add-customer-dialog/add-customer-dialog.component';
import { CustomersService } from 'src/app/services/customers.service';
import { PaginationResult } from 'ng-lightquery';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatIcon } from '@angular/material/icon';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'da-customers',
    templateUrl: './customers.component.html',
    styleUrl: './customers.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, MatFormField, MatLabel, MatInput, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatIconButton, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})

export class CustomersComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private dialog = inject(MatDialog);
  customersService = inject(CustomersService);
  private customersClient = inject(CustomersClient);

  private $filter = new Subject<string>();
  private $destroy = new Subject<boolean>();
  displayedColumns = ['name', 'countOfClients', 'action'];
  customersPaginated = signal<PaginationResult<GetCustomer>>(null);

  ngOnInit(): void {
    this.$filter.pipe(takeUntil(this.$destroy), debounceTime(250)).subscribe((filterWord: string) => this.applyFilter(filterWord));

    this.customersService.paginationResult.pipe(takeUntil(this.$destroy)).subscribe(
      r => this.customersPaginated.set(r)
    );
  }

  ngOnDestroy(): void {
    this.customersService.setQueryParameter('filter', null);
    this.$destroy.next(true);
    this.$destroy.complete()
  }

  filter(filterWord: string): void {
    this.$filter.next(filterWord);
  }

  applyFilter(filterWord: string): void {
    this.customersService.setQueryParameter('filter', filterWord.trim().toLowerCase() || null);
  }

  showClients(customerId: string): void {
    this.router.navigate(['customers', 'list', customerId]);
  }

  refresh(): void {
    this.customersService.forceRefresh();
  }

  addCustomer(): void {
    this.dialog.open(AddCustomerDialogComponent).afterClosed().subscribe(name => {
      if (name) {
        this.customersClient.createCustomer({ name }).subscribe({
          next: () => {
            this.refresh();
          },
          error: (err) => {
            console.error(err)
          }
        });
      }
    });
  }

  removeCustomer(event: MouseEvent, row: GetCustomer): void {
    event.stopPropagation();
    this.dialog.open(ConfirmDialogComponent, { data: { typeWord: 'customer', name: row.name } }).afterClosed().subscribe(isRemove => {
      if (isRemove) {
        this.customersClient.deleteCustomer(row.id).subscribe({
          next: () => {
            this.refresh();
          },
          error: (err) => {
            console.error(err);

          }
        });
      }
    });
  }

  onPage(pageEvent: PageEvent) {
    this.customersService.page = pageEvent.pageIndex + 1;
    this.customersService.pageSize = pageEvent.pageSize;
  }

  onSort(event: { active: string; direction: string }) {
    if (!event.direction) {
      this.customersService.sort = null;
    } else {
      this.customersService.sort = { propertyName: event.active, isDescending: event.direction === 'desc' };
    }
  }
}
